import { NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MyTradesBase } from '@zero/statistics/feature-statistics/base';

@Component({
  selector: 'statistics-my-trades',
  templateUrl: './my-trades.component.html',
  styleUrls: ['../../styles/statistics.scss', './my-trades.component.scss'],
  imports: [TranslocoPipe, NgTemplateOutlet],
})
export class MyTradesComponent extends MyTradesBase {}
